import type { CancelToken } from 'axios';
import type { CategoriesResponse, CategoryData } from '@/types/Category.types';
import slaydApi from './axiosInstance';

export const apiCategories = async (): Promise<CategoriesResponse> => {
  try {
    const response = await slaydApi.get<CategoriesResponse>('/api/categories/');
    if (!response.data) throw new Error('Invalid response');
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw new Error('Error fetching categories');
  }
};

interface FetchCategoryOptions {
  page?: number;
  minPrice?: number;
  maxPrice?: number;
  sale?: boolean; // <-- added
  config?: {
    cancelToken?: CancelToken;
  };
}

export const fetchCategoryProducts = async (
  categoryPath: string,
  options: FetchCategoryOptions = {}
): Promise<CategoryData> => {
  try {
    const { page = 1, minPrice, maxPrice, sale, config } = options;
    const params = new URLSearchParams();
    params.append('page', page.toString());

    if (minPrice !== undefined) {
      params.append('min_price', minPrice.toString());
    }
    if (maxPrice !== undefined) {
      params.append('max_price', maxPrice.toString());
    }
    if (sale !== undefined) {
      params.append('sale', sale ? 'true' : 'false');
    }

    const response = await slaydApi.get<CategoryData>(
      `/api${categoryPath}/?${params.toString()}`,
      config
    );
    if (!response.data) throw new Error('Invalid response');
    return response.data;
  } catch (error) {
    console.error('Error fetching category products:', error);
    throw new Error('Error fetching category products');
  }
};

export const fetchSubcategoryProducts = async (
  subcategorySlug: string,
  options: FetchCategoryOptions = {}
): Promise<CategoryData> => {
  try {
    const { page = 1, minPrice, maxPrice, sale, config } = options;
    const params = new URLSearchParams();
    params.append('page', page.toString());

    if (minPrice !== undefined) {
      params.append('min_price', minPrice.toString());
    }
    if (maxPrice !== undefined) {
      params.append('max_price', maxPrice.toString());
    }
    if (sale !== undefined) {
      params.append('sale', sale ? 'true' : 'false');
    }

    const response = await slaydApi.get<CategoryData>(
      `/api/subcategory/${subcategorySlug}/?${params.toString()}`,
      config
    );
    if (!response.data) throw new Error('Invalid response');
    return response.data;
  } catch (error) {
    console.error('Error fetching subcategory products:', error);
    throw new Error('Error fetching subcategory products');
  }
};
